export default {
  "config": {
    "trial": "tones-3",
    "id": "fosq10",
    "type": "bar",
    "title": "Change From Baseline to Week 12 in FOSQ-10 Total Score<sup>4</sup>",
    "xAxis": {
      "groups": [
        "pbo",
        "sol-375",
        "sol-75",
        "sol-150",
        "sol-300"
      ],
      "padding": 0.1,
      "label": {
        "text": "Treatment arm"
      },
      "overrides": {
        "pbo": "Placebo<br><no-break>(n = 114)</no-break>",
        "sol-375": "<no-break>Solriamfetol 37.5 mg</no-break><br><no-break>(n = 56)</no-break>",
        "sol-75": "<no-break>Solriamfetol 75 mg</no-break><br><no-break>(n = 58)</no-break>",
        "sol-150": "<no-break>Solriamfetol 150 mg</no-break><br><no-break>(n = 116)</no-break>",
        "sol-300": "<no-break>Solriamfetol 300 mg</no-break><br><no-break>(n = 115)</no-break>"
      },
      "shadedRegion": [],
      "scale": "scaleBand"
    },
    "yAxis": {
      "low": 0,
      "high": 4,
      "inc": 1,
      "label": {
        "text": [
          "Change from baseline, LS mean (SE)"
        ]
      }
    },
    "legend": [],
    "footnotes": [
      "The maximum recommended dose for solriamfetol in the USA PI is 150 mg.<sup>27</sup>",
      "<no-break><sup>§</sup><em>P</em> < 0.0005</no-break> vs placebo;<no-break> <sup>#</sup><em>P</em> < 0.0001</no-break> vs placebo."
    ],
    "useFootnoteTooltip": false,
    "trendLines": [
      {
        "y": 1.7,
        "color": "#000",
        "label": {
          "text": "MCID",
          "textColor": "#000"
        },
        "lineType": "dashed"
      }
    ],
    "chartLegend": []
  },
  "data": [
    {
      "x": "pbo",
      "bars": [
        {
          "name": "pbo",
          "color": "#868686",
          "y": 1.7,
          "label": {
            "text": 1.7,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": "sol-375",
      "bars": [
        {
          "name": "sol-375",
          "color": "#006e8a",
          "y": 2,
          "label": {
            "text": 2,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": "sol-75",
      "bars": [
        {
          "name": "sol-75",
          "color": "#ffce00",
          "y": 2.5,
          "label": {
            "text": 2.5,
            "sup": "",
            "override": ""
          }
        }
      ]
    },
    {
      "x": "sol-150",
      "bars": [
        {
          "name": "sol-150",
          "color": "#73cac3",
          "y": 3,
          "label": {
            "text": 3,
            "sup": "§",
            "override": ""
          }
        }
      ]
    },
    {
      "x": "sol-300",
      "bars": [
        {
          "name": "sol-300",
          "color": "#be5b92",
          "y": 3.2,
          "label": {
            "text": 3.2,
            "sup": "#",
            "override": ""
          }
        }
      ]
    }
  ]
};